import axios from 'axios'
import Vue from 'vue'

const { VUE_APP_NAME, VUE_APP_VERSION, VUE_APP_API_URL } = process.env

const axiosApiClient = axios.create({
	baseURL: VUE_APP_API_URL,
	headers: {
		common: {
			'X-LLM-APPNAME': VUE_APP_NAME,
			'X-LLM-VERSION': VUE_APP_VERSION,
		},
	},
	timeout: 30000,
})

axiosApiClient.interceptors.request.use((request) => {
	const authToken = `Bearer ${Vue.$cookies.get("auth_token")}`
	return {
		...request,
		headers: {
			...request.headers || {},
			Authorization: authToken
		}
	}
})

export default axiosApiClient
